var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qualification" }, [
    _c("div", { staticClass: "container qualification-body" }, [
      _c("h3", { staticClass: "qualification-title" }, [
        _vm._v("如果你符合下列条件 诚邀您共创辉煌")
      ]),
      _c(
        "div",
        { staticClass: "qualification-body-list" },
        _vm._l(_vm.contents, function(val, key) {
          return _c(
            "div",
            {
              key: key,
              class: [
                "qualification-body-item",
                { active: val.index === _vm.currentIndex }
              ],
              on: {
                mouseenter: function($event) {
                  _vm.currentIndex = val.index
                }
              }
            },
            [
              _c("div", { staticClass: "qualification-item-icon" }, [
                _c("img", {
                  attrs: {
                    src:
                      _vm.currentIndex == val.index
                        ? val.icon_active
                        : val.icon,
                    alt: val.title
                  }
                })
              ]),
              _c("h3", { staticClass: "qualification-item-title" }, [
                _vm._v(_vm._s(val.title))
              ]),
              _c("p", { staticClass: "qualification-item-text" }, [
                _vm._v(_vm._s(val.text))
              ]),
              _c(
                "nuxt-link",
                {
                  staticClass: "qualification-item-button",
                  attrs: { tag: "a", to: "/" }
                },
                [_vm._v("我要加入")]
              )
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4202d710", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4202d710","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/cooperation/Qualification.vue
// module id = xQ4A
// module chunks = 0